import React from "react";
import "../Styles/pageStyles.css";
import Highlights from "./Highlights";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "./Tucson.css"
import Interier from "./Interier";
import Convenience from "./Convenience";
import { useTranslation } from "react-i18next";

export default function Tucson() {
  const { t } = useTranslation();

  return (
    <div>
      <div>
        <img
          className="page-main-img"
          src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/highlights/tucson-nx4-2023-kv-pc.jpg"
          alt="tucson"
        />
        <div className=" second-navs">
          <Tabs
            defaultActiveKey="higlights"
            id="justify-tab-example"
            className="mb-3 second-navbar"
            justify
          >
            <Tab eventKey="higlights" title={t("higlights")}>
              <Highlights />
            </Tab>
            <Tab eventKey="interier" title={t("interier")}>
              <Interier />
            </Tab>
            {/* <Tab eventKey="performance" title={t("performance")}></Tab> */}
            <Tab eventKey="convenience" title={t("convenience")}>
              <Convenience />
            </Tab>
          </Tabs>
          <div className="notify-text">
              <p>
              <p>{t("info-sec")}</p>
              </p>
            </div>
        </div>
      </div>
    </div>
  );
}
